import http from '../_http'

const webshell = {
  //default
  summaryWebshell: (m) => { return http.get(`manager/wsfinder/webshell`, m); },
  listWebshell: (m) => { return http.post(`manager/wsfinder/webshell/list`, m); },
  detailWebshell: (m) => { return http.get(`manager/wsfinder/webshell/${m.id}`); },

  //crud
  insertWebshell: (m) => { return http.post(`manager/wsfinder/webshell`, m); },
  updateWebshell: (m) => { return http.put(`manager/wsfinder/webshell`, m); },
  deleteWebshell: (m) => { return http.delete(`manager/wsfinder/webshell/${m.id}`); },

  //approve
  approveWebshell: (m) => { return http.get(`manager/wsfinder/webshell/approve/${m.id}`); },

  //reject
  rejectWebshell: (m) => { return http.post(`manager/wsfinder/webshell/reject`, m); },
}

export default webshell

export { webshell }